import type {
  Configuration,
  CreateRoleRequest,
  UpdateRoleRequest,
} from '@repo/api-gw-sdk';
import { IamApi } from '@repo/api-gw-sdk';

import type { HttpClient } from './httpClient';

const baseUrl = '/roles';

export const roles = (httpClient: HttpClient, config: Configuration) => {
  const iamApi = new IamApi(config);

  return {
    useList: () =>
      httpClient.execute(iamApi.listRoles.bind(iamApi), baseUrl, ''),
    create: (createRoleInput: CreateRoleRequest) =>
      iamApi.createRole(createRoleInput),
    update: (id: string, updateRoleInput: UpdateRoleRequest) =>
      iamApi.updateRole(id, updateRoleInput),
    delete: (id: string) => iamApi.deleteRole(id),
    getRoleUsage: (id: string) => iamApi.getRoleUsage(id),
    useListPermissions: () =>
      httpClient.execute(
        iamApi.listPermissions.bind(iamApi),
        baseUrl,
        '/permissions'
      ),
  };
};
